// React&NextJS
import React from 'react'
// Styles
import s from '../Authentication.module.scss'
// Components
import { Container } from '../../../core/container/Container'
import { Text } from '../../../core/text/Text'
import { WhiteBox } from '../../../core/whiteBox/WhiteBox'

const IslykillLoading = ({ closeButton = null }) => {
    return (
        <Container>
            <WhiteBox className={s.container}>
                {closeButton}
                <Text variant="h2">Skrái netfang</Text>
                <Text variant="p-18">
                    Uppfæri notendaupplýsingarnar þínar...
                </Text>
                <div className={s.loader}>
                    <div className={s.loaderInside}></div>
                </div>
            </WhiteBox>
        </Container>
    )
}

export default IslykillLoading
